import script from "./AddCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCompany.vue?vue&type=script&setup=true&lang=js"

import "./AddCompany.vue?vue&type=style&index=0&id=5be06b36&scoped=true&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be06b36"]])

export default __exports__